import api from '../utils/api';

/**
 * Dashboard service for handling dashboard-related API calls
 */
const dashboardService = {
  /**
   * Get complete dashboard data (replaces multiple API calls)
   * @returns {Promise<Object>} - Complete dashboard data
   */
  getDashboardData: async () => {
    try {
      // Fetch both stats and historical data
      const statsResponse = await api.get('/dashboard/stats');
      const historicalResponse = await api.get('/dashboard/historical?days=30');
      
      // Combine the data into the expected format
      const combinedData = {
        summary: {
          instances: {
            connected: statsResponse.data.instances.connected,
            total: statsResponse.data.instances.total
          },
          assistants: {
            active: statsResponse.data.assistants.running,
            total: statsResponse.data.assistants.total
          },
          contacts: {
            total: statsResponse.data.contacts.total
          },
          messages: {
            byAssistant: statsResponse.data.messages.sentByAssistants,
            total: statsResponse.data.messages.total
          },
          campaigns: {
            active: statsResponse.data.campaigns.running,
            total: statsResponse.data.campaigns.total
          },
          finance: {
            currentBalance: statsResponse.data.finance?.currentBalance || 0,
            currentBalanceCurrency: statsResponse.data.finance?.currentBalanceCurrency || 'USD'
          }
        },
        // Transform historical data into the format expected by the charts
        messagesDynamics: historicalResponse.data.messages.map(item => ({
          date: item.date,
          count: item.count, // Real data from the API
          received: 0, // Set to 0 as we're focusing on sent messages
          sent: item.count, // All messages are sent messages
          receivedByAssistant: 0, // Set to 0 as we're focusing on sent messages
          sentByAssistant: 0 // We don't have this breakdown from the API
        })),
        // Mock data for assistants and campaigns stats
        assistantsStats: Array.from({ length: 5 }, (_, i) => ({
          id: i + 1,
          name: `Assistant ${i + 1}`,
          status: i % 3 === 0 ? 'active' : (i % 3 === 1 ? 'paused' : 'stopped'),
          chatsCount: Math.floor(Math.random() * 100),
          sentMessagesCount: Math.floor(Math.random() * 500)
        })),
        campaignsStats: Array.from({ length: 5 }, (_, i) => ({
          id: i + 1,
          name: `Campaign ${i + 1}`,
          status: i % 3 === 0 ? 'active' : (i % 3 === 1 ? 'paused' : 'stopped'),
          contactsCount: Math.floor(Math.random() * 1000),
          instancesCount: Math.floor(Math.random() * 5) + 1,
          period: {
            start: new Date(2025, 7, 1).toISOString(),
            end: new Date(2025, 8, 1).toISOString()
          }
        }))
      };
      
      return combinedData;
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      throw error;
    }
  }
  //
  // /**
  //  * @deprecated Use getDashboardData instead
  //  * Get dashboard statistics
  //  * @returns {Promise<Object>} - Dashboard statistics
  //  */
  // getDashboardStats: async () => {
  //   try {
  //     console.warn('getDashboardStats is deprecated. Use getDashboardData instead.');
  //     const response = await api.get('/dashboard/stats');
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error fetching dashboard statistics:', error);
  //     throw error;
  //   }
  // },
  //
  // /**
  //  * @deprecated Use getDashboardData instead
  //  * Get historical data for dashboard entities
  //  * @param {number} days - Number of days to get data for (default: 7)
  //  * @returns {Promise<Object>} - Historical data for dashboard entities
  //  */
  // getHistoricalData: async (days = 7) => {
  //   try {
  //     console.warn('getHistoricalData is deprecated. Use getDashboardData instead.');
  //     const response = await api.get(`/dashboard/historical?days=${days}`);
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error fetching historical data:', error);
  //     throw error;
  //   }
  // }
};

export default dashboardService;